module.exports = "<div class=Panels><div v-for=\"panel in panels\" @click=selected(panel.value) v-bind:class=\"{'Panel__active': panel.value === formInput}\" class=Panel><div class=Panel__header><div class=Panel__title>{{ panel.label }}</div></div><div class=Panel__body>{{ panel.tip }}</div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/nav/panels.vue
// module id = 464
// module chunks = 0